import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { WEBHOOK_URL_BASE } from '../../core/constants';
import { HttpUtils } from '../../shared/http-utils';
import { map } from 'rxjs/operators';
import { WebhookEvent, WebhookEventSearchResult } from './webhook-event.model';
import { SearchObjectResult } from '../../shared/search-object-result.model';
import { SortDirection } from '../../shared/sort-direction';
import { WebhookEventSearchCriteria } from './webhook-event-search-criteria.model';

@Injectable()
export class WebhookEventService {

  private WEBHOOKS_EVENTS_URI = 'events';

  constructor(private http: HttpClient) {}

  public getEventById(eventId: string): Observable<WebhookEvent> {
    const headers = HttpUtils.createHeaders();
    const url = `${WEBHOOK_URL_BASE}/api/${this.WEBHOOKS_EVENTS_URI}/${eventId}`;
    return this.http.get(url, { headers }).pipe(map(result => WebhookEvent.fromDto(result)));
  }

  public searchWebhookEvents(
    page: number, size: number, sortColumn: string, direction: SortDirection, criteria: WebhookEventSearchCriteria
  ): Observable<SearchObjectResult<WebhookEventSearchResult>> {

    let params = new HttpParams();
    if (criteria.subscriberId) {
      params = params.set('subscriberId', criteria.subscriberId);
    }
    if (criteria.eventTypes) {
      criteria.eventTypes.forEach(eventType => params = params.append('eventTypes', eventType.toString()));
    }
    if (criteria.eventStatuses) {
      criteria.eventStatuses.forEach(eventStatus => params = params.append('eventStatuses', eventStatus.toString()));
    }
    if (criteria.externalReference) {
      params = params.set('externalReference', criteria.externalReference);
    }
    if (criteria.triggeredStartDate) {
      params = params.set('triggeredStartDate', criteria.triggeredStartDate.toString());
    }
    if (criteria.triggeredEndDate) {
      params = params.set('triggeredEndDate', criteria.triggeredEndDate.toString());
    }
    params = params.set('timeZone', criteria.timeZone);
    params = params.set('page', page.toString());
    params = params.set('size', size.toString());
    params = params.set('sort', sortColumn);
    params = params.set('direction', direction.toString());

    const headers = HttpUtils.createHeaders();
    const url = `${WEBHOOK_URL_BASE}/api/${this.WEBHOOKS_EVENTS_URI}/search`;
    return this.http.get(url, { headers, params })
      .pipe(map(result => SearchObjectResult.fromDto(result, WebhookEventSearchResult.fromDto)));
  }

  public retrySendingEvent(eventId: string): Observable<WebhookEvent> {
    const headers = HttpUtils.createHeaders();
    const url = `${WEBHOOK_URL_BASE}/api/${this.WEBHOOKS_EVENTS_URI}/${eventId}/retry`;
    return this.http.post(url, {}, { headers })
      .pipe(map(result => WebhookEvent.fromDto(result)));
  }

  public bulkRetrySendingEvents(eventIds: string[]): Observable<WebhookEvent[]> {
    const headers = HttpUtils.createHeaders();
    const url = `${WEBHOOK_URL_BASE}/api/${this.WEBHOOKS_EVENTS_URI}/bulk-retry`;

    let params = { eventIds };

    return this.http.post(url, {}, { headers, params })
      .pipe(map((result: any[]) => result.map(e => WebhookEvent.fromDto(e))));
  }
}
